<template>
  <nav class="uk-navbar-container" uk-navbar>
    <div class="uk-navbar-center navEscritorio">
        <a href="#" class="logoNav"><img src="/public/img/recursos/nufit_logo.png"></a>
        <ul class="uk-navbar-nav">
            <li>
                <a href="#adulto" uk-scroll>{{ $t('nav[0].titulo') }}</a>
                <div class="uk-navbar-dropdown">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                        <li><a href="#croqueta_nufit_adulto" uk-scroll>{{ $t('nav[1].titulo') }}</a></li>
                        <li><a href="#beneficio_nufit_adulto" uk-scroll>{{ $t('nav[2].titulo') }}</a></li>
                        <li><a href="#presentacion_nufit_adulto" uk-scroll>{{ $t('nav[3].titulo') }}</a></li>
                        <li><a href="#indicaciones_nufit_adulto" uk-scroll>{{ $t('nav[4].titulo') }}</a></li>
                    </ul>
                </div>
            </li>
            <li>
                <a href="#cachorro" uk-scroll>{{ $t('nav[5].titulo') }}</a>
                <div class="uk-navbar-dropdown">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                        <li><a href="#croqueta_nufit_cachorro" uk-scroll>{{ $t('nav[1].titulo') }}</a></li>
                        <li><a href="#beneficio_nufit_cachorro" uk-scroll>{{ $t('nav[2].titulo') }}</a></li>
                        <li><a href="#presentacion_nufit_cachorro" uk-scroll>{{ $t('nav[3].titulo') }}</a></li>
                        <li><a href="#indicaciones_nufit_cachorro" uk-scroll>{{ $t('nav[4].titulo') }}</a></li>
                    </ul>
                </div>
            </li>
            <li><a href="#empaque" uk-scroll v-html="$t('nav[6].titulo') "></a></li>
            <li><a href="#compra" uk-scroll v-html="$t('nav[7].titulo') "></a></li>
            <li><a href="https://nufit.com.mx/blog/" >BLOG</a></li>
            <li class="lang_menu" style="padding-left:50px;">
              <input id="les" type="radio" :key="`Lang${0}`" value="es" v-model="$i18n.locale">
              <label for="les"> <span style="background: url(/public/img/esp.png)" alt=""></span></label>
            </li>
            <li class="lang_menu">
              <input id="len" type="radio" :key="`Lang${1}`" value="en" v-model="$i18n.locale">
              <label for="len"> <span style="background: url(/public/img/usa.jpeg)" alt=""></span></label>
            </li>
            <li class="lanNavHid"><span style="font-size: 33px;color: white;">|</span>  </li>
            <li class="redes">
              <a href="https://www.facebook.com/nufitmx" target="_blank"> <img src="/public/img/recursos/btn_fb.png" style="width:20px;"/></a>
            </li>
            <li class="redes">
              <a href="https://www.instagram.com/nufitmx/" target="_blnak" > <img src="/public/img/recursos/btn_ig.png" style="width:20px;" /></a>
            </li>
        </ul>
    </div>

    <button uk-toggle="target: #my-id" type="button" class="btnmenuMovil"><span uk-icon="icon: menu; ratio: 1.5"></span></button>
    <a href="#" class="logoMovil" style="padding-top:10px!important;"><img src="/public/img/recursos/nufit_logo.png"></a>
    <ul class="redesmovil movil">
      <li class="lang_menu">
        <input id="les" type="radio" :key="`Lang${0}`" value="es" v-model="$i18n.locale">
        <label for="les"> <span style="background: url(/public/img/esp.png)" alt=""></span></label>
      </li>
      <li class="lang_menu">
        <input id="len" type="radio" :key="`Lang${1}`" value="en" v-model="$i18n.locale">
        <label for="len"> <span style="background: url(/public/img/usa.jpeg)" alt=""></span></label>
      </li>
      <li><span style="font-size: 33px;color: white;">|</span>  </li>
      <li class="redes">
        <a href="https://www.facebook.com/nufitmx" target="_blank"> <img src="/public/img/recursos/btn_fb.png" style="width:20px;"/></a>
      </li>
      <li class="redes">
        <a href="https://www.instagram.com/nufitmx/" target="_blank"> <img src="/public/img/recursos/btn_ig.png" style="width:20px;" /></a>
      </li>
    </ul>
    <div id="my-id" uk-offcanvas>
      <div class="uk-offcanvas-bar menuMovil">
        <a href="#" class="logoMovil"><img src="/public/img/recursos/nufit_logo.png"></a>
        <a class="" >{{ $t('nav[0].titulo') }}</a>
          <div uk-dropdown="mode: click" class="dropMovil">
            <ul class="uk-nav uk-navbar-dropdown-nav">
              <li><a href="#croqueta_nufit_adulto" uk-scroll v-on:click="closeDrop()">{{ $t('nav[1].titulo') }}</a></li>
              <li><a href="#beneficio_nufit_adulto" uk-scroll v-on:click="closeDrop()">{{ $t('nav[2].titulo') }}</a></li>
              <li><a href="#presentacion_nufit_adulto" uk-scroll v-on:click="closeDrop()">{{ $t('nav[3].titulo') }}</a></li>
              <li><a href="#indicaciones_nufit_adulto" uk-scroll v-on:click="closeDrop()">{{ $t('nav[4].titulo') }}</a></li>
            </ul>
          </div>
        <a class="">{{ $t('nav[5].titulo') }}</a>
          <div uk-dropdown="mode: click" class="dropMovil">
            <ul class="uk-nav uk-navbar-dropdown-nav">
              <li><a href="#croqueta_nufit_cachorro" uk-scroll v-on:click="closeDrop()">{{ $t('nav[1].titulo') }}</a></li>
              <li><a href="#beneficio_nufit_cachorro" uk-scroll v-on:click="closeDrop()">{{ $t('nav[2].titulo') }}</a></li>
              <li><a href="#presentacion_nufit_cachorro" uk-scroll v-on:click="closeDrop()">{{ $t('nav[3].titulo') }}</a></li>
              <li><a href="#indicaciones_nufit_cachorro" uk-scroll v-on:click="closeDrop()">{{ $t('nav[4].titulo') }}</a></li>
            </ul>
          </div>
        <a href="#empaque" uk-scroll v-html="$t('nav[6].titulo')" v-on:click="closeDrop()"> </a>
        <a href="https://nufit.com.mx/blog/">BLOG </a>
        
        </div>
    </div>
  </nav>
    
</template>
<script>
export default {
  name: 'Home',
  mounted(){

  },
  components: {
  },
  methods:{
    closeDrop(){
      console.log("____")
      UIkit.offcanvas("#my-id").hide();
    }
  }

}
</script>
<style>
.lanNavHid:hover{
  background: none!important;
}
#app{
  z-index: 999;
}
.lang_menu{
  padding: 0px 10px;
  cursor: pointer;
}
.lang_menu:hover, .redes:hover{
  background: #5E3C32!important;
}
.lang_menu input{
  opacity: 0;
  display: none;
}
.lang_menu span{
  width: 18px;
  height: 18px;
  display: inline-block;
  border-radius: 12px;
  background-size: cover!important;
  background-position: center center!important;
  margin-top: 6px;
  cursor: pointer;
}
.redes a{
  box-sizing: content-box!important;
  padding: 0px 12px!important;
}
.redes a:hover{
  background: none!important;
}
.redes span{
  width: 18px;
  height: 18px;
  display: inline-block;
  border-radius: 12px;
  background-size: cover!important;
  background-position: center center!important;
}
.logoNav{
  padding-right: 50px;
}
body{
  scroll-behavior: smooth!important;
  background-image: url('/public/img/recursos/ricepaper.png');
}
nav{
  background: #5E3C32!important;
  top: 0px;
  z-index: 9999;
  text-align: left;
  text-align: center;
  position: fixed!important;
  width: 100%;
  height: 80px;
}
nav .navEscritorio img{
  width: 100px;
}
nav .navEscritorio li{
  display: flex!important;
  align-items: center;
  /* padding-left:20px;
  display: table-cell;
  height: 100px;
  list-style-type: none;
  margin: 10px;
  vertical-align: middle; */
}
.uk-navbar-nav>li>a{
  color: #fff!important;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
}
/* nav .navEscritorio li a{
  font-weight: bold;
  vertical-align: middle;
  height:80px;
  padding: 0px 10px;
} */
nav .navEscritorio li a:hover, nav .navEscritorio li:hover{
  color: white!important;
  background: #B59C70;
}
nav .navEscritorio li a:active{
  color:white!important;
}
.navEscritorio .uk-navbar-dropdown{
  margin-top:0px;
  text-align: left;
  padding: 0px;
}
.navEscritorio .uk-navbar-dropdown-nav{
  width: 100%;
}
.uk-navbar-dropdown-nav li a{
  height: auto;
  padding: 15px 20px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
}

.navEscritorio .uk-navbar-dropdown-nav li a:hover{
  color: white;
  background: #B59C70;
  width: 100%;
  text-decoration: underline;}
.btnmenuMovil{
  background: none!important;
  border: none!important;
}
.btnmenuMovil span{
  color: white;
  font-size: 30px;
}
.logoMovil{
  width: 120px;
  display: block;
  height: 50px;
  border-bottom:none!important ;
  padding-left: 15px;
}
.logoMovil:hover{
  background: none!important;
}
.logoMovil img{
  max-width: 100px; 
}
.uk-offcanvas-bar{
  background: #5E3C33!important;
  -webkit-box-shadow: 2px 0 8px 1px #f1f1f1;
  box-shadow: 2px 0 8px 1px #f1f1f1;
  padding: 15px 0px;
  text-align: left;
}
.menuMovil a{
  font-weight: bold;
  display: block;
  border-bottom: solid 1px white;
  margin-bottom: 2px;
  padding: 5px 0px 5px 15px;
}
.menuMovil a:hover{
  color: white!important;
  background: #5F3C31;
}
.btnmenuMovil, .logoMovil{
  display: none;
}
@media only screen and (max-width: 720px){
  .btnmenuMovil, .logoMovil{
    display: block;
  }
  .navEscritorio{
    display: none;
  }
  nav{
    height: 60px;
    text-align: left;
  }
  .dropMovil{
    margin-top:0px;
  }
  .uk-dropdown{
    padding: 0px;
  }
  .redesmovil{
    position: absolute;
    right: 0px;
    margin: 0px;
    padding: 0px;
    top: 4px
  }
  .redesmovil .lang_menu, .redesmovil .redes a{
    padding: 0px 15px;
  }
  .redesmovil li{
    display: inline-block;
    vertical-align: middle;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue